import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Roles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      count: 10,

      id: "",
      uid: "",
      name: "",
      permission: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count;
    loading(true);
    let [result] = await Promise.all([GET("admin/setting/roles/list", { page: page, data_search: this.state.filter_search })]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      count,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, name, permission } = this.state;
    if (!name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อบทบาท");
      return;
    }

    loading(true);
    let body = {
      name,
      permission: permission.filter((e) => e.name_en).flatMap((item) => ["read", "create", "update", "delete"].filter((action) => item[action]).map((action) => `${item.name_en}.${action}`)),
    };

    let result = !uid ? await POST("admin/setting/roles/create", body) : await PUT("admin/setting/roles/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
      let result = await DELETE("admin/setting/roles/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const { modal_create, modal_update, filter_search, data, count, id, uid, name, permission } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">บทบาท</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 roles.create"
                onClick={async () => {
                  this.setState({
                    id: "",
                    uid: "",
                    name: "",
                    permission: Object.keys(global.role).map((e) => (e.includes("title") ? { title_en: e, title_th: global.role[e] } : { name_en: e, name_th: global.role[e], read: false, create: false, update: false, delete: false })),
                    modal_create: true,
                  });
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-100">ลำดับ</td>
                    <td className="text-nowrap">ชื่อบทบาท</td>
                    {/* <td className="text-nowrap">รายละเอียด</td> */}
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">{item.name || "-"}</td>
                      {/* <td>
                        {item.permission.length ? item.permission.map(({ permission_key }) => `${global.role[permission_key.split(".")[0]]} (${["ดู", "สร้าง", "แก้ไข", "ลบ"].filter((t, i) => permission_key.includes(["read", "create", "update", "delete"][i])).join("")}) `).join(", ") : "-"}
                      </td> */}
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="roles.update"
                            type="update"
                            onClick={() => {
                              this.setState({
                                ...item,
                                permission: Object.entries(global.role).map(([k, v]) =>
                                  k.includes("title")
                                    ? { title_en: k, title_th: v }
                                    : {
                                        name_en: k,
                                        name_th: v,
                                        ...["read", "create", "update", "delete"].reduce((acc, type) => {
                                          acc[type] = item.permission.find((p) => p?.includes(k) && p?.includes(type));
                                          return acc;
                                        }, {}),
                                      }
                                ),
                                modal_update: true,
                              });
                            }}
                          />
                          <BtnIcon
                            className="roles.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}บทบาท</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อบทบาท{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อบทบาท..."
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <td>ชื่อสิทธิ์</td>
                    <td className="wpx-50 text-center">
                      ทั้งหมด
                      <br />
                      <input
                        type="checkbox"
                        checked={!permission.filter((e) => e.name_en).find((e) => !e.read || !e.create || !e.update || !e.delete)}
                        onChange={(e) => {
                          const value = e.target.checked;
                          this.setState({ permission: permission.map((item) => ({ ...item, read: value, create: value, update: value, delete: value })) });
                        }}
                      />
                    </td>
                    <td className="wpx-50 text-center">
                      ดู
                      <br />
                      <input
                        type="checkbox"
                        checked={!permission.filter((e) => e.name_en).find((e) => !e.read)}
                        onChange={(e) => {
                          this.setState({ permission: permission.map((item) => ({ ...item, read: e.target.checked })) });
                        }}
                      />
                    </td>
                    <td className="wpx-50 text-center">
                      สร้าง
                      <br />
                      <input
                        type="checkbox"
                        checked={!permission.filter((e) => e.name_en).find((e) => !e.create)}
                        onChange={(e) => {
                          this.setState({ permission: permission.map((item) => ({ ...item, create: e.target.checked })) });
                        }}
                      />
                    </td>
                    <td className="wpx-50 text-center">
                      แก้ไข
                      <br />
                      <input
                        type="checkbox"
                        checked={!permission.filter((e) => e.name_en).find((e) => !e.update)}
                        onChange={(e) => {
                          this.setState({ permission: permission.map((item) => ({ ...item, update: e.target.checked })) });
                        }}
                      />
                    </td>
                    <td className="wpx-50 text-center">
                      ลบ
                      <br />
                      <input
                        type="checkbox"
                        checked={!permission.filter((e) => e.name_en).find((e) => !e.delete)}
                        onChange={(e) => {
                          this.setState({ permission: permission.map((item) => ({ ...item, delete: e.target.checked })) });
                        }}
                      />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {permission?.map((item, index) => {
                    return item.title_th ? (
                      <tr key={index}>
                        <td className="bg-primary fw-bold text-white py-1" colSpan={6}>
                          {item.title_th}
                        </td>
                      </tr>
                    ) : (
                      <tr key={index}>
                        <td>{item.name_th}</td>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={item.read && item.create && item.update && item.delete}
                            onChange={(e) => {
                              const value = e.target.checked;
                              permission[index] = { ...item, read: value, create: value, update: value, delete: value };
                              this.setState({ permission });
                            }}
                          />
                        </td>
                        {["read", "create", "update", "delete"].map((key) => (
                          <td key={key} className="text-center">
                            <input
                              type="checkbox"
                              checked={item[key]}
                              onChange={() => {
                                permission[index][key] = !item[key];
                                this.setState({ permission });
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
